import type { ReactNode } from 'react'

import { Typography } from '@twisto/components/atoms/typography'

import { useBannerContext } from '../../banner.context'

import * as styles from './banner-title.styles'

type Props = {
  children: ReactNode
  className?: string
  highlighted?: boolean
}

export const BannerTitle = ({
  children,
  className,
  highlighted = false,
}: Props) => {
  const { variant } = useBannerContext()

  return (
    <Typography
      className={className}
      color="textPrimary"
      component="h2"
      css={[
        styles.text,
        highlighted && styles.textVariant[variant],
        highlighted && styles.textUppercase,
      ]}
      fontWeight={highlighted ? 'medium' : 'regular'}
      variant="b3"
    >
      {children}
    </Typography>
  )
}
